import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import styles from './index.styl';

const Badge = ({ className, colored, large, text }) => (
  <div
    {...{ className }}
    styleName={classNames('root', {
      'root--colored': colored,
      'root--large': large,
    })}
  >
    <span styleName="text" children={text} />
  </div>
);

Badge.propTypes = {
  className: PropTypes.string,
  colored: PropTypes.bool,
  large: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

Badge.defaultProps = {
  colored: false,
  large: false,
  className: '',
};

export default CSSModules(Badge, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Badge/index.jsx